<template>
    <div class="flat-view">
        <amf-form :title="title" class="container">
            <div v-if="!busy" class="container">
                <v-client-table :data="teamMembers" :columns="columns" :options="options">
                    <template v-slot:fullName="{ row }">
                        <div>
                            <a @click.prevent="showUserStats(row)" v-if="row.userId" href="#">{{ row.fullName }}</a>
                            <span v-else>{{ row.fullName }}</span>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </amf-form>
    </div>
</template>

<script>

import uuid from "uuid/v4";
import { modalService } from '../framework/utils/modal-service';
import UserWorkflowStatsModal from "./UserWorkflowStatsModal";
import parentViewMixin from '../framework/utils/parent-view-mixin';
import { getVueTablesOptions } from '../framework/utils/utils';
import EmployerSpecialistTypeModal from "../employer/EmployerSpecialistTypeModal";

export default {
    mixins: [parentViewMixin],
    data() {
        return {
            teamMembers: [],
            columns: ["fullName", "totalEmployerCount", "totalWorkflowCount", "time1", "time2", "time3"],
            options: {
                ...utils.getVueTablesOptions(),
                texts: {
                    filter: null,
                    count: ''
                },
                uniqueKey: "userId",
                headings: { 
                    fullName: "Name",
                    totalEmployerCount: "Employers",
                    totalWorkflowCount: "Workflows",
                    time1: "5-10 days old",
                    time2: "11-20 days old",
                    time3: "21+ days old",
                },
            },
        }
    },
    created() {
        this.load();
    },
    computed: {
        ...amfx.map("session", "user"),
        menuItems() {
            if(this.can.assignEmployerSpecialist){
                return ["Download employer specialists", "Download blank employer specialists sheet","Upload employer specialists"];}
            else{
                return[];
            }
        },
        title() {
            return "Client Success Team";
        }
    },
    methods: {
        ...amfx.map('session', 'sessionUserId:userId'),
        async showUserStats(user) {
            var data = await modalService.show("workflow-stats", UserWorkflowStatsModal, { userId: user.userId });
            this.$router.push({ name: "Workflows", query: { userId: data.userId, actionItemType: data.actionItemType, sDate: data.updatedStartDate, eDate: data.updatedEndDate } });
        },
        getUniqueWorkflowStatuses(users) {
             var a = _.chain(users)
                        .map(u => _.flatten(u.workflowTypes.map(wt => _.keys(wt.employerCountPerStatus))))
                            .flatten().uniq().value();
                            return a;
        },
        getWorkflowByType(type) {
        },
        extendTeamMember(m) {
            m.fullName = m.firstName + " " + m.lastName;
            m.time1 = _(m.countPerUpdatedDate).keys().filter(date => this.inDaysRange(date, 5, 10)).sumBy(date => m.countPerUpdatedDate[date]);
            m.time2 = _(m.countPerUpdatedDate).keys().filter(date => this.inDaysRange(date, 11, 20)).sumBy(date => m.countPerUpdatedDate[date]);
            m.time3 = _(m.countPerUpdatedDate).keys().filter(date => this.inDaysRange(date, 21, 1000)).sumBy(date => m.countPerUpdatedDate[date]);
        },
        inDaysRange(date, minDaysOld, maxDaysOld) {
            var dateM = moment(date);
            var diffDays = dateM.diff(moment(new Date()), "days");
            return (diffDays >= -maxDaysOld && diffDays <= -minDaysOld);
        },
        async load() {
             let teamMembers = await romeApi.get("/workflow/team/stats?specialistType=cam");
             teamMembers.forEach(this.extendTeamMember);
             var total = {
                 fullName: "Total",
                 totalEmployerCount: _.sumBy(teamMembers, "totalEmployerCount"),
                 totalWorkflowCount: _.sumBy(teamMembers, "totalWorkflowCount"),
                 time1: _.sumBy(teamMembers, "time1"),
                 time2: _.sumBy(teamMembers, "time2"),
                 time3: _.sumBy(teamMembers, "time3")
             };
             teamMembers.unshift(total);
             this.teamMembers = teamMembers;
        },
        async downloadEmployerSpecialists() {
            await modalService.show("employerSpecialistTypeModal", EmployerSpecialistTypeModal, { 
                title: "Select Bulk Specialist Assignment Type",
                blank: false,
                download: true,
           });
        },
        async downloadBlankEmployerSpecialistsSheet() {
             await modalService.show("employerSpecialistTypeModal", EmployerSpecialistTypeModal, { 
                title: "Select Blank Specialist Assignment Type",
                blank: true,
                download: true,
           });
        },
        async uploadEmployerSpecialists() {
            await modalService.show("employerSpecialistTypeModal", EmployerSpecialistTypeModal, { 
                title: "Select File For Upload",
                upload: true,
           });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/workflow/CssTeamStats.vue